import { css } from '@emotion/react';

const appStyles = {
    root: css`
        height: 100vh;
        width: 100vw;
    `,
};

export default appStyles;
